var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "scroll-panel row-fluid align-items-end col-12 col-lg-6 p-0 m-0",
      staticStyle: { "transition-delay": "0s" }
    },
    [
      _c("section", { staticClass: "h-100" }, [
        _c("h4", { staticClass: "mt-0" }, [_vm._v("My Account")]),
        _vm._v(" "),
        _c("div", { staticClass: "list-view mb-5" }, [
          _c("ul", { staticClass: "list-group" }, [
            _c(
              "li",
              {
                staticClass: "list-group-item list-group-item-action",
                on: {
                  click: function($event) {
                    return _vm.setPage("Password")
                  }
                }
              },
              [_vm._v("Change Password")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "mt-0" }, [_vm._v("Settings")]),
        _vm._v(" "),
        _c("div", { staticClass: "list-view mb-5" }, [
          _c("ul", { staticClass: "list-group" }, [
            _c(
              "li",
              {
                staticClass: "list-group-item list-group-item-action anonymous",
                on: { click: _vm.setAnonymous }
              },
              [
                _vm._v("Anonymise Data\n                    "),
                _c("i", {
                  staticClass:
                    "fas fa-solid fa-eye-slash float-right anonymous",
                  class: _vm.user.anonymous ? "active" : "fa-times-circle"
                }),
                _c("br"),
                _vm._v(" "),
                _vm._m(0)
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "mt-0" }, [_vm._v("About")]),
        _vm._v(" "),
        _c("div", { staticClass: "list-view mb-5" }, [
          _c("ul", { staticClass: "list-group" }, [
            _c(
              "li",
              { staticClass: "list-group-item list-group-item-action" },
              [
                _c(
                  "a",
                  { attrs: { href: this.$company.urlAbout, target: "_blank" } },
                  [_vm._v("About " + _vm._s(this.$companyName))]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "list-group-item list-group-item-action" },
              [
                _c(
                  "a",
                  {
                    attrs: { href: this.$company.urlPrivacy, target: "_blank" }
                  },
                  [_vm._v("Privacy Policy")]
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "mt-0" }, [_vm._v("Contact Us")]),
        _vm._v(" "),
        _c("div", { staticClass: "list-view mb-5" }, [
          _c("ul", { staticClass: "list-group" }, [
            _c(
              "li",
              { staticClass: "list-group-item list-group-item-action" },
              [
                _c(
                  "a",
                  {
                    attrs: { href: this.$company.urlContact, target: "_blank" }
                  },
                  [_vm._v("Contact Us")]
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-outline-secondary col mt-0 p-2 btn-primary",
            attrs: { type: "button" },
            on: { click: _vm.logout }
          },
          [_vm._v("Logout")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "text-center mt-2" }, [
          _c("small", [_vm._v("App build version " + _vm._s(this.$appVersion))])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "rounded alert-warning mt-2 mb-0 p-0 px-1 small" },
      [
        _c("small", [
          _vm._v("Check above to anonymise answers and mood submissions.")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6deb95f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6deb95f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/More.vue
// module id = null
// module chunks = 